import { useEffect, useState } from 'react';
import Modal from '../../../../component/modal/Modal';
import Button from '../../../../component/ui/Button';
import { fetchCustomerCredit } from '../../../../services/invoices';
import { applyInvoiceFromCreditNote } from '../../../../services/sales_credit_note';
import { toast } from 'react-toastify';
import AmountCreditWidget from './amountCreditWidget';

const ApplyCreditCustomerModal = ({ setIsOpen, isOpen, invoiceId, onSuccess }) => {
	const [customerCredit, setCustomerCredit] = useState(null);
	const [loading, setLoading] = useState(false);

	const handleApplyCredit = async () => {
		const creditsToApply = Number(customerCredit?.credits_to_apply || 0);
		if (creditsToApply <= 0) {
			toast.error('No credits available to apply');
			return;
		}

		try {
			setLoading(true);
			const payload = {
				invoices: [
					{
						id: Number(invoiceId),
						applied_credit_amount: creditsToApply,
					},
				],
				total_credit_applied: creditsToApply,
			};

			const res = await applyInvoiceFromCreditNote(payload);
			if (res?.success) {
				toast.success(res?.message || 'Credit note applied successfully');
				setIsOpen(false);
				if (onSuccess) {
					onSuccess();
				}
			} else {
				toast.error(res?.message || 'Failed to apply credit note');
			}
		} catch (error) {
			toast.error(error?.message || 'Something went wrong while applying credit');
		} finally {
			setLoading(false);
		}
	};

	const getCustomerCredit = async () => {
		try {
			const res = await fetchCustomerCredit(invoiceId);
			setCustomerCredit(res);
		} catch (error) {
			console.error('Error retrieving customer credit:', error);
		}
	};

	useEffect(() => {
		if (isOpen) {
			getCustomerCredit();
		}
	}, [isOpen]);

	return (
		<Modal
			className="customerCreditModal"
			title="Apply Customer Credits"
			subtitle="Review credit use before completing this transaction"
			isOpen={isOpen}
			onClose={() => {
				setIsOpen(false);
			}}
			cancelButton={() => {
				setIsOpen(false);
			}}
		>
			<div
				className="p-2 rounded mb-3"
				style={{ backgroundColor: '#f0ffda' }}
			>
				<AmountCreditWidget
					label="Invoice Due Before"
					amount={customerCredit?.invoice_due_before || 0}
				/>
				<AmountCreditWidget
					label="Credits Available"
					amount={customerCredit?.credits_available || 0}
				/>
				<AmountCreditWidget
					label="Credits to Apply"
					amount={customerCredit?.credits_to_apply || 0}
				/>
				<AmountCreditWidget
					label="Invoice Due After"
					amount={customerCredit?.invoice_due_after || 0}
				/>
			</div>
			<div className="mb-3 border rounded p-2 border-gray">
				{customerCredit?.credit_notes?.length > 0 &&
					customerCredit.credit_notes.map((note) => (
						<AmountCreditWidget
							key={note.credit_note_id || note.credit_note_number}
							label={note.credit_note_number}
							amount={note.available_balance}
						/>
					))}
			</div>
			<div className="d-flex justify-content-end gap-2">
				<Button
					type="button"
					className="mt-0 btn-gray add-pro"
					button="Cancel"
					disabled={loading}
					onClick={() => {
						setIsOpen(false);
					}}
				/>

				<Button
					type="button"
					button="Apply Credit"
					className="mt-0 px-4 btn-primary relative"
					loader={loading}
					disabled={loading}
					onClick={handleApplyCredit}
				/>
			</div>
		</Modal>
	);
};

export default ApplyCreditCustomerModal;
